import React, { useEffect, useState } from "react";
import { getStorage, ref, getMetadata } from "firebase/storage";

export default function FileSizeDisplay({ filePath }) {
  const [size, setSize] = useState("Loading...");

  useEffect(() => {
    let isMounted = true;

    async function fetchFileSize() {
      if (!filePath) {
        setSize("No file");
        return;
      }

      try {
        const storage = getStorage(); // ensure firebase is initialized
        const fileRef = ref(storage, filePath); // e.g., "uploads/myFile.pdf"
        const metadata = await getMetadata(fileRef);

        const sizeInMB = (metadata.size / (1024 * 1024)).toFixed(2); // convert bytes to MB

        if (isMounted) setSize(`${sizeInMB} MB`);
      } catch (error) {
        console.error("Error fetching file size:", error);
        // if (isMounted) setSize("Error fetching size");
        if (isMounted) setSize("");
      }
    }

    fetchFileSize();

    return () => { isMounted = false; };
  }, [filePath]);

  return <p>{size}</p>;
}
